var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdultswim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 521.5 93",
    style: {
      enableBackground: "new 0 0 521.5 93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 172") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.7,0.7v0.7h-1.9v4.9H513V1.3h-1.9V0.7H515.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M516.2,0.7h1.1l1.6,4.7l1.6-4.7h1.1v5.6h-0.7V3c0-0.1,0-0.3,0-0.6V1.5l-1.6,4.7h-0.7l-1.6-4.7v0.2 c0,0.2,0,0.4,0,0.6v3.9h-0.7L516.2,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,57.1c0-3.1,0.8-4.8,2.6-6.2c1.5-1.2,3.8-1.3,9-4.1c0,2.3-0.1,5.1-0.1,9.8c0,5.6-3.2,7.6-6.7,7.6 C45.7,64.2,44,61.5,44,57.1z M44.3,35.7c0.1-4.8,1.4-7.6,6.1-7.6c3.7,0,5.2,2.2,5.2,5.5c0,4.2-0.9,5-6,6.4 c-4.6,1.2-10.8,2.3-14.9,4.5s-6.8,7.7-6.8,14.2c0,12,5.4,17,14.8,17c5.5,0,10.8-2.9,13-7.8H56c0,2.2,0.3,4.3,0.9,6.4H73 c-2-2.5-2-7.8-2-12V33.6c0-11.7-6.1-16.5-19.7-16.5c-6.9,0-11.6,0.9-15.5,3.6s-6.2,7.3-6.3,14.9H44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.9,46.8c0,10.8-1,16.8-6,16.8c-6.3,0-6.5-8.5-6.5-17.5c0-10.1,0.3-16.8,6.4-16.8 C105.4,29.3,105.9,36.9,105.9,46.8z M106.2,74.2h16V0.8h-16.6v23.9h-0.2c-2.8-6-7.8-7.5-12.4-7.5c-13.7,0-16.1,12.4-16.1,29.7 c0,20.8,6,28.8,17.2,28.8c7.4,0,10.8-4.4,12-8.2h0.2L106.2,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.7,74.2h-16v-6.6h-0.2c-2.4,4.9-7.2,8-13.4,8c-9.5,0-14.5-4.7-14.5-15.4V18.6h16.7v37.9 c0,4,1.8,6.4,4.8,6.4s6-2.5,6-7.9V18.6h16.7L173.7,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.5,0.8h16.7v73.4h-16.7V0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210,30.1h-6.9V18.6h6.9V2.3h16.7v16.4h7.7v11.5h-7.7v28.1c0,3.9,1.4,5.1,5.4,5.1c0.8,0,1.6-0.1,2.4-0.2v11.1 c-3.2,0.4-6.4,0.6-9.6,0.6c-11.5,0-14.8-2.1-14.8-15L210,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269,56.5c0,2.1,0.3,4.3,1.1,6.3c0.9,1.5,2.5,2.6,5.1,2.6c3.9,0,6-2.5,6-5.7c0-2.6-1.2-5-6.4-6.8 c-13.7-4.6-20.3-7.3-20.3-19c0-11.1,7.8-16.8,21.2-16.8c15.6,0,20.1,7.6,20.1,15.6v1.8h-14.8v-1c0-4.8-2-6.2-5.5-6.2 c-4.4,0-5.6,2.2-5.6,5.1c0,9.9,26.6,3.3,26.6,24.9c0,11.2-7.5,18.2-21.3,18.2c-14.9,0-21.2-5.6-21.2-16.7v-2.5H269z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.6,18.6h16.7l5.4,41h0.2l6.3-41H345l5.9,41h0.2l5.9-41h16L361,74.2h-18.9l-6.1-41h-0.2l-6.5,41h-19.1 L298.6,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.9,18.6h16.7v55.6h-16.7V18.6z M377.9,0h16.7v12.8h-16.7V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.2,18.6h16v6.6h0.2c2.4-4.9,7.2-8,13.4-8c4.8,0,11.2,0.9,13.7,8.5c3.9-6.5,7.6-8.5,13.8-8.5 c9.5,0,14.5,4.7,14.5,15.4v41.6h-16.6V36.3c0-4-1.8-6.4-4.8-6.4s-6,2.5-6,7.9v36.4h-16.6V36.3c0-4-1.7-6.4-4.8-6.4s-6,2.5-6,7.9 v36.4h-16.6V18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0.7h26v11.5H15.4v69.3H26V93H0V0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.5,81.5h10.6V12.2h-10.6V0.7h26V93h-26V81.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultswim);
export default __webpack_public_path__ + "static/media/adultswim.5c8066c6de4204b448e17e1abd535f7b.svg";
export { ForwardRef as ReactComponent };